import {
  MetafieldSelectedsOrErrorType,
  MetafieldSelectedsOrErrorListV2Type,
} from '@tiendanube/common';
import { MetafieldsSelected } from '../../pages/components/Variants/types';
import {
  generateMetafieldsPayload,
  MetafieldsRequest,
} from '../getUpdateProductPayload/generateMetafieldsPayload';

export function generateVariantMetafieldsPayload(
  originalMetafields: MetafieldsSelected | undefined,
  newMetafields:
    | MetafieldSelectedsOrErrorListV2Type
    | MetafieldSelectedsOrErrorType
    | undefined,
): { metafields: MetafieldsRequest[] } | undefined {
  if (newMetafields === 'error' || !newMetafields) {
    return undefined;
  }

  if (
    newMetafields &&
    'fromApi' in newMetafields &&
    'internals' in newMetafields
  ) {
    const variantMetafields = generateMetafieldsPayload(
      originalMetafields,
      newMetafields,
    );
    if (!variantMetafields || variantMetafields.metafields.length === 0) {
      return undefined;
    }
    return {
      metafields: variantMetafields.metafields,
    };
  }

  return {
    metafields: newMetafields.map((metafield) => ({
      uuid: metafield.id,
      value: metafield.selected,
    })),
  };
}
